import { TrackingEvent } from '@marketplace-web/observability/event-tracker-data'

import { ElectronicsLandingPageEvent } from '../constants/electronics'
import { HoVLandingPageEvent } from '../constants/house-of-vinted'
import { InfluencerLandingPageEvent } from '../constants/influencer'
import { NewAgainLandingPageEvent } from '../constants/new-again'

// Source: https://github.com/vinted/dwh-schema-registry/blob/5387d2ce7b44ee93711a15dfb97c60a4d984f22c/avro/events/common/shared/user.avdl#L25
type UserTarget = 'hyperlink' | 'cta_redirect'

type LandingPageEventsArgs = {
  referrer?: string
  event?:
    | HoVLandingPageEvent
    | ElectronicsLandingPageEvent
    | NewAgainLandingPageEvent
    | InfluencerLandingPageEvent
  targetDetails?: string
  deviceId?: string
}

type LandingPageEventsExtra = {
  referrer?: string
  target_details?: string
  device_id?: string
}

export const landingPageEvent = (args: LandingPageEventsArgs): TrackingEvent => {
  const { referrer, targetDetails, event: eventName, deviceId } = args

  const extra: LandingPageEventsExtra = {}

  if (targetDetails) extra.target_details = targetDetails

  if (referrer) extra.referrer = referrer

  if (deviceId) extra.device_id = deviceId

  return {
    event: eventName || 'user.view_screen',
    extra,
  }
}

type ClickEventArgs = {
  target: UserTarget
  screen?: string | null
  targetDetails?: string | null
  path?: string | null
  env?: string | null
}

type ClickEventExtra = {
  target: UserTarget
  screen?: string
  target_details?: string
  path?: string | null
  env?: string | null
}

export const clickEvent = (args: ClickEventArgs): TrackingEvent => {
  const { target, screen, targetDetails, env, path } = args
  const extra: ClickEventExtra = { target }

  if (screen) extra.screen = screen

  if (targetDetails) extra.target_details = targetDetails

  if (env) extra.env = env

  if (path) extra.path = path

  return {
    event: 'user.click',
    extra,
  }
}

type LandingPageViewScreenArgs = {
  screen?: string
  referrer?: string
  path?: string
  event?: string
}

type LandingPageViewScreenExtra = {
  screen?: string
  path?: string
  referrer?: string
}

export const ViewLandingPageEvent = (args: LandingPageViewScreenArgs): TrackingEvent => {
  const { screen, path, referrer } = args

  const extra: LandingPageViewScreenExtra = {
    screen,
    path,
    referrer,
  }

  return {
    event: 'user.view_screen',
    extra,
  }
}
